import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  Switch,
  Collapse,
  ListItem,
  List,
  ListItemText,
  ListItemIcon,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { fetchScreensAndFeatures } from "../../../containers/actions/common/rolesAndAccessActions";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1890ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1890ff",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "90%",
    marginTop: theme.spacing(2),
  },
  listContainer: {
    border: "1px solid #ccc",
    padding: 0,
  },
  screen: {
    padding: theme.spacing(1),
    backgroundColor: "#f5f5f5",
  },
  feature: {
    padding: theme.spacing(1),
    borderTop: "1px solid #ccc",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
}));

// const screensAndFeaturesData = [
//   {
//     screen_id: 1,
//     screen_name: "GRN Receipts",
//     screen_access: true,
//     features: [
//       { feature_id: 1, feature: "Export to Excel", feature_access: true },
//       { feature_id: 2, feature: "Approve GR", feature_access: true },
//       { feature_id: 3, feature: "View GR Details", feature_access: true },
//       { feature_id: 4, feature: "Download GR Files", feature_access: false },
//       { feature_id: 5, feature: "Edit GR Record", feature_access: false },
//     ],
//   },
//   {
//     screen_id: 2,
//     screen_name: "Schedule Agreements",
//     screen_access: false,
//     features: [
//       { feature_id: 6, feature: "View Schedule", feature_access: false },
//     ],
//   },
//   {
//     screen_id: 3,
//     screen_name: "Delivery Schedule Details",
//     screen_access: true,
//     features: [
//       {
//         feature_id: 7,
//         feature: "Edit Delivery Schedule",
//         feature_access: true,
//       },
//       {
//         feature_id: 8,
//         feature: "Delete Delivery Schedule",
//         feature_access: false,
//       },
//     ],
//   },
// ];

export default function ViewPermissions({ selectedRole }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  // const [screensAndFeatures, setScreensAndFeatures] = useState(
  //   screensAndFeaturesData
  // );
  const [expandedSections, setExpandedSections] = useState({});

  const ScreensAndFeaturesData = useSelector((state) => {
    return state?.pcmp?.common?.rolesAndAccess?.screensAndFeatureDetails
      ? state?.pcmp?.common?.rolesAndAccess?.screensAndFeatureDetails
      : [];
  });

  // const handleToggleScreen = (screenId) => {
  //   setScreensAndFeatures((prev) =>
  //     prev.map((screen) =>
  //       screen.screen_id === screenId
  //         ? {
  //             ...screen,
  //             screen_access: !screen.screen_access,
  //             features: screen.screen_access
  //               ? screen.features.map((feature) => ({
  //                   ...feature,
  //                   feature_access: false, // Turn off all features if screen is turned off
  //                 }))
  //               : screen.features, // Leave features unchanged when turning on
  //           }
  //         : screen
  //     )
  //   );
  // };

  // const handleToggleFeature = (screenId, featureId) => {
  //   setScreensAndFeatures((prev) =>
  //     prev.map((screen) =>
  //       screen.screen_id === screenId
  //         ? {
  //             ...screen,
  //             features: screen.features.map((feature) =>
  //               feature.feature_id === featureId
  //                 ? { ...feature, feature_access: !feature.feature_access }
  //                 : feature
  //             ),
  //           }
  //         : screen
  //     )
  //   );
  // };

  useEffect(() => {
    if (selectedRole) {
      dispatch(
        fetchScreensAndFeatures({
          collaboratorRoleID: selectedRole?.collaborator_role_id,
          saas_user_id: "0",
        })
      );
    }
  }, [selectedRole]);

  const handleExpand = (screenId) => {
    setExpandedSections((prev) => ({
      ...prev,
      [screenId]: !prev[screenId],
    }));
  };
  return (
    <Box className={classes.container}>
      <List className={classes.listContainer} style={{ padding: "16px" }}>
        <Typography
          style={{
            fontSize: "1.3rem",
            fontWeight: "bold",
            paddingLeft: "2rem",
          }}
          gutterBottom
        >
          Permissions
        </Typography>
        {ScreensAndFeaturesData?.data?.screensAndFeatures.map((screen) => (
          <React.Fragment key={screen.screen_id}>
            <ListItem
              button
              className={classes.screen}
              onClick={() => handleExpand(screen.screen_id)}
            >
              <ListItemIcon
                style={{
                  visibility:
                    screen.features && screen.features.length > 0
                      ? "visible"
                      : "hidden",
                }}
              >
                {expandedSections[screen.screen_id] ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )}
              </ListItemIcon>
              <Grid
                style={{ display: "flex", gap: "10rem", alignItems: "center" }}
              >
                <Grid style={{ width: "30rem" }}>
                  <ListItemText>
                    <Typography style={{ fontWeight: 550 }}>
                      {screen.screen_name}
                    </Typography>
                  </ListItemText>
                </Grid>
                <Grid style={{ width: "30rem" }}>
                  <Switch
                    classes={{ root: classes.root }}
                    checked={screen.screen_access}
                    disabled // Disable the switch, since no changes are allowed
                  />
                </Grid>
              </Grid>
            </ListItem>
            {screen.features && screen.features.length > 0 && (
              <Collapse
                in={expandedSections[screen.screen_id]}
                timeout="auto"
                unmountOnExit
              >
                <List>
                  {screen.features.map((feature) => (
                    <ListItem
                      key={feature.feature_id}
                      button
                      className={classes.feature}
                    >
                      <Grid
                        style={{
                          display: "flex",
                          gap: "13.5rem",
                          alignItems: "center",
                        }}
                      >
                        <Grid style={{ width: "30rem" }}>
                          <ListItemText>{feature.feature}</ListItemText>
                        </Grid>

                        <Grid style={{ width: "30rem" }}>
                          <Switch
                            classes={{ root: classes.root }}
                            checked={feature.feature_access}
                            disabled // Disable the switch, since no changes are allowed
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
}
